import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatDateToISOCustom } from "../../utils/dateUtils";

const DatePickerWithoutStore = ({ 
  placeholder = "Select date", 
  defaultValue = null, 
  value: controlledValue, 
  onChange 
}) => {
  const [selectedDate, setSelectedDate] = useState(controlledValue || defaultValue);
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    setSelectedDate(controlledValue);
  }, [controlledValue]);

  const handleChange = (date) => {
    if (!date) {
      setSelectedDate(null);
      onChange?.(null);
    } else {
      const formatted = formatDateToISOCustom(date);
      setSelectedDate(formatted);
      onChange?.(formatted);
    }
  };

  console.log(controlledValue);

  return (
    <div>
      <DatePicker
        selected={selectedDate ? new Date(selectedDate) : null}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        onChange={handleChange}
        dateFormat="dd-MM-yy"
        className={`border ${
          focused ? "!border-[#8f94a1]" : "border-[#D2D4DA]"
        } ${focused || selectedDate ? "font-semibold" : ""} 
          w-full rounded text-[#8f94a1] text-[14px] h-9 px-2`}
        placeholderText={placeholder}
        isClearable
      />
    </div>
  );
};

export default DatePickerWithoutStore;
